import { useMemo } from 'react';
import get from 'lodash/get';
import { COUNT_INVITATIONS_PER_PAGE } from 'constants/constants';
import { useQuery } from '@apollo/client/react';
import { InvitationsByLoanConsultantDocument } from 'graphql/generated/graphql';

interface IUseGetInvitationsByLoanConsultantArgs {
  currentPage: number;
  filter: string;
}

const useGetInvitationsByLoanConsultant = ({
  currentPage,
  filter,
}: IUseGetInvitationsByLoanConsultantArgs) => {
  const { data, loading, refetch } = useQuery(InvitationsByLoanConsultantDocument, {
    variables: {
      offset: COUNT_INVITATIONS_PER_PAGE * (currentPage - 1),
      limit: COUNT_INVITATIONS_PER_PAGE,
      filter,
    },
  });

  const invitations = useMemo(
    () => get(data, 'invitationsByLoanConsultant.invitations', []),
    [data],
  );
  const total = useMemo(() => get(data, 'invitationsByLoanConsultant.total', 0), [data]);
  const xlsxUrl = useMemo(() => get(data, 'invitationsByLoanConsultant.xlsxUrl', ''), [data]);

  return { invitations, total, xlsxUrl, loading, refetch };
};

export default useGetInvitationsByLoanConsultant;
